import { render, staticRenderFns } from "./CamaraVODVerDetalle.vue?vue&type=template&id=644c596e&"
import script from "./CamaraVODVerDetalle.vue?vue&type=script&lang=ts&"
export * from "./CamaraVODVerDetalle.vue?vue&type=script&lang=ts&"
import style0 from "./CamaraVODVerDetalle.vue?vue&type=style&index=0&acoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports